import { render, staticRenderFns } from "./PersoneCal.vue?vue&type=template&id=2938b63b&scoped=true&"
import script from "./PersoneCal.vue?vue&type=script&lang=js&"
export * from "./PersoneCal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2938b63b",
  null
  
)

export default component.exports